// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';
// ----------------------------------------------------------------------

type IProps = {
  name: string;
  options: { id: string | number | undefined; name: string }[];
  hasEmptyOption?: boolean;
  rules?: any;
};

type Props = IProps & TextFieldProps;

export default function RHFSelect({ name, options, hasEmptyOption, ...other }: Props) {
  const { control, watch } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={other.rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          value={watch(name) || ''}
          fullWidth
          SelectProps={{ native: true }}
          error={!!error}
          helperText={error?.message}
          {...other}
        >
          {hasEmptyOption && <option value={''} />}
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </TextField>
      )}
    />
  );
}
